export default "__VITE_ASSET__BAyk6sDy__"